var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.262,
    height: 18.877,
    viewBox: "0 0 18.262 18.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65267",
    "data-name": "Path 65267",
    d: "M.22,3.182a24.5,24.5,0,0,1,4.1,3.284c-.7,3.07,2.079,5.524,4.61,6.969.991.566,1.428.962,2.531.772L15.8,18.461C7.629,21.206-1.543,9.691.22,3.182Zm12.358,9.93.953-.968a.715.715,0,0,1,1.008-.008l3.512,3.458a.715.715,0,0,1,.008,1.008l-.953.968a.715.715,0,0,1-1.008.008L12.586,14.12a.714.714,0,0,1-.008-1.008ZM1.076,1.147,1.768.308A.85.85,0,0,1,2.961.192l3.6,2.962a.851.851,0,0,1,.115,1.194l-.692.839A.85.85,0,0,1,4.787,5.3L1.192,2.34a.85.85,0,0,1-.115-1.193Z",
    transform: "translate(0)",
    fill: "#191bc3",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.a04378ea0b1bbb1b9b3bf68e8a62e654.svg";
export { ForwardRef as ReactComponent };